import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { mapDispatchToOnClick, mapStateToOpen } from '../../../../containers/orders-drawer/sections/section-container-helper';
import { OrderDrawerSection } from '../../../../enums/order-drawer-section';
import { useIsLocalDeliveryServiceSelected } from '../../../../fulfillment-planner/hooks/use-is-local-delivery-service-selected';

const sectionId = OrderDrawerSection.pickupInformation;

export const useOrdersSidebarPickupInformationSection = () => {
  const dispatch = useDispatch();
  const { open } = useSelector((state) => mapStateToOpen(state, sectionId));
  const { onClick } = mapDispatchToOnClick(dispatch, sectionId);
  const toggleCollapsableSection = useCallback(() => onClick(open), [open, onClick]);

  const isLocalDelivery = useIsLocalDeliveryServiceSelected();

  return {
    isLocalDelivery,
    open,
    toggleCollapsableSection,
  };
};
